module.exports = __webpack_public_path__ + "img/donate.b8605b00.png";